import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserService } from '../../services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { PasswordViewerDirective } from 'src/app/directives/password-viewer/password-viewer.directive';
import { PasswordToggleButtonComponent } from 'src/app/components/password-toggle-button/password-toggle-button.component';
import { User } from 'src/app/model/User';
import { confirmPasswordMatchValidator, customPasswordValidator } from 'src/app/shared/password.validator';

@Component({
    selector: 'app-user-security-settings',
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    PasswordViewerDirective,
    PasswordToggleButtonComponent,
    ReactiveFormsModule
],
    templateUrl: './user-security-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./user-security-settings.component.scss']
})
export class UserSecuritySettingsComponent {
  @Input() userData!: User;

  /** Password reset form */
  public passwordForm: FormGroup = new FormGroup({
    currentPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [customPasswordValidator]),
    confirmNewPassword: new FormControl('', [Validators.required, confirmPasswordMatchValidator('newPassword')]),
  });

  /** Submission state for the form */
  isSubmitting = false;

  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) {}

  async changePassword(): Promise<void> {
    this.isSubmitting = true;

    try {
      // Reset password
      const { currentPassword, newPassword } = this.passwordForm.value;
      await firstValueFrom(this.userService.changePassword(currentPassword, newPassword));

      this.passwordForm.reset();
      this.toastr.success('Password changed successfully!');
    } catch (error) {
      // Catch errors
      this.toastr.error('An error occurred while changing your password. Please try again later.', 'Error');
      console.error('[USER-SECURITY-SETTINGS-COMPONENT]: Error changing password', error);
    } finally {
      this.isSubmitting = false;
    }
  }
}
